export class GrupoFilter {
  codigo?: string;
  nombre?: string;
  descripcion?: string;
}
